import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["resourceType", "placeholder", "styles", "id", "value", "hasError", "resourceParams"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _map from 'lodash/map';
import _keyBy from 'lodash/keyBy';
import _values from 'lodash/values';
import _castArray from 'lodash/castArray';
import _difference from 'lodash/difference';

// Services
import { getLookupByKeys, lookupSearch } from '@tekion/tekion-base/services/lookupService';
// Utils

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import RESOURCE_TYPES from '../constants/withAsyncResource.resourceTypes';
import { ROWS } from './withAsyncResource.constant';

// Helpers
import getOptionMapperForResource from '../helpers/withAsyncResource.optionMapper';
import { getLoadingMessage, getNoOptionsMessage } from '../../../helpers/advancedSelect.general';
import { getSelectStyles } from '../../../helpers/advancedSelect.style';
import { getSelectedValueCache, getSanitizedValue, hasValueInCache, getValuesToBeResolved, searchStaticOptions, getOptions, getValueIds, getDefaultFilterOption } from './withAsyncResource.helper';
var withAsyncResource = function withAsyncResource(WrappedComponent) {
  var WithAsyncResource = /*#__PURE__*/function (_Component) {
    _inherits(WithAsyncResource, _Component);
    var _super = _createSuper(WithAsyncResource);
    function WithAsyncResource(props) {
      var _this;
      _classCallCheck(this, WithAsyncResource);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "setCacheValue", function (newCache) {
        return _this.setState(function (_ref) {
          var selectedValueCache = _ref.selectedValueCache;
          return {
            selectedValueCache: _objectSpread(_objectSpread({}, selectedValueCache), newCache)
          };
        });
      });
      _defineProperty(_assertThisInitialized(_this), "getSelectStyles", defaultMemoize(getSelectStyles));
      _defineProperty(_assertThisInitialized(_this), "addStaticOptions", function (options, inputString, page) {
        if (page > 0) {
          return options;
        }
        var staticOptions = _this.props.staticOptions;
        var staticOptionResult = searchStaticOptions(staticOptions, inputString);
        return [].concat(_toConsumableArray(staticOptionResult), _toConsumableArray(options));
      });
      _defineProperty(_assertThisInitialized(_this), "handleLoadOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var inputString,
          page,
          _this$props,
          resourceType,
          value,
          filters,
          _this$props$sort,
          sort,
          lookUpSearchApi,
          lookupByKeysApi,
          selectedValueCache,
          _yield$lookUpSearchAp,
          lookupResources,
          hasMore,
          resources,
          options,
          optionsWithStatic,
          valueToResolve,
          lookupValues,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              inputString = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
              _this$props = _this.props, resourceType = _this$props.resourceType, value = _this$props.value, filters = _this$props.filters, _this$props$sort = _this$props.sort, sort = _this$props$sort === void 0 ? EMPTY_ARRAY : _this$props$sort, lookUpSearchApi = _this$props.lookUpSearchApi, lookupByKeysApi = _this$props.lookupByKeysApi;
              selectedValueCache = _this.state.selectedValueCache;
              _context.next = 6;
              return lookUpSearchApi(resourceType, {
                searchQuery: inputString,
                filters: filters,
                pageInfo: {
                  start: page * ROWS,
                  rows: ROWS
                },
                sort: sort
              });
            case 6:
              _yield$lookUpSearchAp = _context.sent;
              lookupResources = _yield$lookUpSearchAp.resources;
              hasMore = _yield$lookUpSearchAp.hasMore;
              resources = lookupResources || EMPTY_ARRAY;
              options = getOptions(_this.optionMapper, resources);
              optionsWithStatic = _this.addStaticOptions(options, inputString, page);
              valueToResolve = _difference(getValueIds(value), _map(options, 'value'));
              if (!(_isEmpty(valueToResolve) || hasValueInCache(valueToResolve, selectedValueCache))) {
                _context.next = 16;
                break;
              }
              _this.setCacheValue(_keyBy(resources, _this.optionMapper.getOptionValue));
              return _context.abrupt("return", {
                options: optionsWithStatic,
                hasMore: hasMore
              });
            case 16:
              _context.next = 18;
              return lookupByKeysApi(resourceType, valueToResolve);
            case 18:
              lookupValues = _context.sent;
              _this.setCacheValue(_keyBy([].concat(_toConsumableArray(resources), _toConsumableArray(_values(lookupValues))), _this.optionMapper.getOptionValue));
              return _context.abrupt("return", {
                options: optionsWithStatic,
                hasMore: hasMore
              });
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (values, eventDetails) {
        var onChange = _this.props.onChange;
        onChange({
          value: _map(_castArray(values), 'value'),
          eventDetails: eventDetails,
          option: values
        });
      });
      var _staticOptions = props.staticOptions;
      var _selectedValueCache = getSelectedValueCache(_staticOptions);
      _this.state = {
        selectedValueCache: _selectedValueCache
      };
      _this.optionMapper = props.resourceType ? getOptionMapperForResource(props.resourceType, props.resourceParams) : EMPTY_OBJECT;
      _this.valueGenerator = getSanitizedValue(_this.optionMapper, _staticOptions);
      return _this;
    }
    _createClass(WithAsyncResource, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;
        var _this$props2 = this.props,
          shouldFetchOnValueChange = _this$props2.shouldFetchOnValueChange,
          value = _this$props2.value,
          resourceType = _this$props2.resourceType,
          lookupByKeysApi = _this$props2.lookupByKeysApi;
        var selectedValueCache = this.state.selectedValueCache;
        if (shouldFetchOnValueChange && !_isEqual(prevProps.value, value) && !hasValueInCache(value, selectedValueCache)) {
          var valuesToResolve = getValuesToBeResolved(value);
          if (_isEmpty(valuesToResolve)) return;
          lookupByKeysApi(resourceType, valuesToResolve).then(function (lookupValues) {
            return _this2.setCacheValue(_keyBy(_values(lookupValues), _this2.optionMapper.getOptionValue));
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          resourceType = _this$props3.resourceType,
          placeholder = _this$props3.placeholder,
          styles = _this$props3.styles,
          id = _this$props3.id,
          value = _this$props3.value,
          hasError = _this$props3.hasError,
          resourceParams = _this$props3.resourceParams,
          restProps = _objectWithoutProperties(_this$props3, _excluded);
        var selectedValueCache = this.state.selectedValueCache;
        var selectStyles = this.getSelectStyles(styles);
        var resourceTypeProps = resourceType ? {
          loadOptions: this.handleLoadOptions,
          value: this.valueGenerator(value, selectedValueCache)
        } : {};
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          newSelect: true,
          loadingMessage: getLoadingMessage,
          noOptionsMessage: getNoOptionsMessage,
          onChange: this.handleChange,
          placeholder: placeholder,
          filterOption: getDefaultFilterOption,
          styles: selectStyles,
          inputId: id,
          id: id,
          error: hasError
        }, resourceTypeProps));
      }
    }]);
    return WithAsyncResource;
  }(Component);
  WithAsyncResource.propTypes = {
    resourceType: PropTypes.oneOf(Object.values(RESOURCE_TYPES)).isRequired,
    resourceParams: PropTypes.object,
    filters: PropTypes.array,
    value: PropTypes.array,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    id: PropTypes.string,
    styles: PropTypes.object,
    hasError: PropTypes.bool,
    shouldFetchOnValueChange: PropTypes.bool,
    staticOptions: PropTypes.array,
    lookUpSearchApi: PropTypes.func,
    lookupByKeysApi: PropTypes.func,
    sort: PropTypes.array
  };
  WithAsyncResource.defaultProps = {
    value: EMPTY_ARRAY,
    filters: EMPTY_ARRAY,
    onChange: _noop,
    placeholder: __('Select'),
    id: '',
    styles: EMPTY_OBJECT,
    resourceParams: EMPTY_OBJECT,
    hasError: false,
    shouldFetchOnValueChange: false,
    staticOptions: EMPTY_ARRAY,
    sort: EMPTY_ARRAY,
    lookUpSearchApi: lookupSearch,
    lookupByKeysApi: getLookupByKeys
  };
  return WithAsyncResource;
};
export default withAsyncResource;